import API from "./APIService";
import UserService from "./UserService";
 
class ExportService {

    /**
     * Authenticated user token.
     */
    USER_TOKEN = new UserService(this).getLoggedInUser().token;


    /**
     * Exports data to MS Excel format
     */
    exportToExcel = (options, page, data, dateRange) => {
    	if(dateRange) {
    		window.open( API.url(`${options}?page=${page}&data=${data}&${dateRange}&token=${this.USER_TOKEN}`,"_blank") );
    		return;
    	}
    	window.open( API.url(`${options}?page=${page}&data=${data}&token=${this.USER_TOKEN}`,"_blank") );        
    }
    
}

export default ExportService;


// WEBPACK FOOTER //
// ./src/services/ExportService.js